import { RAZORPAY_CONFIG, generateOrderIds, validatePaymentAmount } from '../config/razorpayConfig.js';

export const loadRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export const createRazorpayOrder = async (amount, currency = 'INR') => {
  // Validate amount
  validatePaymentAmount(amount);
  
  // Generate unique identifiers for our tracking
  const { orderId, invoiceId, receiptId } = generateOrderIds();
  
  const options = {
    key: RAZORPAY_CONFIG.KEY_ID,
    amount: Math.round(amount * 100), // Razorpay expects amount in paise
    currency: currency || RAZORPAY_CONFIG.PAYMENT.currency,
    name: RAZORPAY_CONFIG.COMPANY.name,
    description: RAZORPAY_CONFIG.COMPANY.description,
    image: RAZORPAY_CONFIG.COMPANY.logo,
    // Don't pass custom order_id - let Razorpay generate it
    receipt: receiptId, // Receipt ID for invoice
    notes: {
      invoice_id: invoiceId,
      custom_order_id: orderId, // Our custom order ID in notes
      order_timestamp: Date.now(),
      merchant: RAZORPAY_CONFIG.COMPANY.name,
      website: RAZORPAY_CONFIG.COMPANY.website
    },
    theme: {
      color: RAZORPAY_CONFIG.THEME.color,
      backdrop_color: RAZORPAY_CONFIG.THEME.backdrop_color
    },
    retry: {
      enabled: RAZORPAY_CONFIG.PAYMENT.retry_enabled,
      max_count: RAZORPAY_CONFIG.PAYMENT.max_retry_count
    },
    timeout: RAZORPAY_CONFIG.PAYMENT.timeout,
    remember_customer: RAZORPAY_CONFIG.PAYMENT.remember_customer,
    send_sms_hash: RAZORPAY_CONFIG.PAYMENT.send_sms_hash,
    allow_rotation: RAZORPAY_CONFIG.PAYMENT.allow_rotation
  };
  
  return { options, orderId, invoiceId, receiptId };
};